import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  nativeInventory: {
    defaultMessage: 'Insufficient inventory. Update stock levels in Product Details or ship from another location.',
    description: 'An error message indicating that the user does not have enough inventory and instructions to adjust known stock levels.',
    id: 'hVruHX',
  },
  externalInventorySource: {
    defaultMessage:
      'Insufficient inventory to fulfill items in this shipment. Choose to update the available stock levels in {inventoryProviderName, select, unknown {your external inventory source} other {{inventoryProviderName}}} or ship from another location.',
    description: 'An error message indicating that the user does not have enough inventory and instructions to adjust known stock levels.',
    id: 'KssZAE',
  },
});
